import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";

const getBranchMembershipPlans = async (branchId) => {
    console.log("Fetching membership plans for branchId:", branchId);
  const db = getFirestore();
  const plansCollection = collection(db, "membershipPlans");
  const q = query(plansCollection, where("branchId", "==", branchId));

  try {
    const querySnapshot = await getDocs(q);
    const plansData = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    console.log("Fetched membership plans:", plansData);
    return plansData; // Returns array of plans, e.g., [{ id, plan_name, price, duration_months }, ...]
  } catch (error) {
    console.error("Error fetching membership plans:", error);
    throw error;
  }
};

export default getBranchMembershipPlans;
